import { render } from "./DiscussionQuestList.vue?vue&type=template&id=36b7a3f8"
import script from "./DiscussionQuestList.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionQuestList.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionQuestList.vue?vue&type=style&index=0&id=36b7a3f8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__